<!--
 * @Author: jzh
 * @Date: 2020-03-18 11:37:36
 * @Description: file content
 * @LastEditTime: 2021-05-06 11:18:16
 * @LastEditors: DQL
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="岗位菜单维护"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :inline="true"
        label-position="right"
        label-width="120px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位代码"
              prop="roleCode"
            >
              <span
                class="c-form__read"
              >
                {{ fd.roleCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位名称"
              prop="roleName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.roleName }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="安全控制类别"
              prop="securityName"
            >
              <span
                class="c-form__read"
              >
                {{ fd.securityName }}
              </span>
              <span
                class="u-text-warning"
              >
                （以下菜单同属于一个安全控制类别）
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-alert
              type="warning"
              :closable="false"
            >
              <template v-slot:title>
                <i class="dev-element-sign" />表示此节点是【菜单页面元素】，【菜单页面元素】提供页面的具体功能！
              </template>
            </el-alert>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="菜单"
              prop="menuRole"
            >
              <div
                class="dev-tree-container"
              >
                <el-tree
                  ref="tree"
                  class="o-tree-overflow--unset"
                  node-key="nodeCode"
                  highlight-current
                  show-checkbox
                  :data="routesMenuTree"
                  :props="defaultProps"
                  :default-expanded-keys="defaultExpandedKeys"
                  :expand-on-click-node="false"
                >
                  <div
                    slot-scope="{ node, data }"
                  >
                    <i
                      v-if="data.menuType==='element'"
                      class="dev-element-sign"
                    />
                    {{ node.data.nodeName }}
                  </div>
                </el-tree>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { menuRoleService, menuTree } from '@/features/system/role/role.service.js';
export default {
  name: 'RoleMenuRelationshipDialog', // 岗位菜单维护
  props: {
    dlParams: {
      type: Object,
      default () {
        return {};
      },
      required: true
    }
  },
  data () {
    return {
      loading: false, // 页面loading状态

      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        roleCode: '',
        roleName: '',
        securityType: '',
        sysMenuVOList: []
      },
      /* 表单参数 End */

      menuData: [], // 菜单数据
      leafMenuList: [], // 菜单叶子节点
      menuElements: {}, // 系统路由所有菜单页面元素

      /* 树组件配置 Start */
      routesMenuTree: [], // 菜单&页面元素数据（树数据）
      // 树组件默认参数配置
      defaultProps: {
        label: 'nodeName',
        children: 'childNodes'
      },
      defaultExpandedKeys: [] // 默认展开节点
      /* 树组件配置 End */

    };
  },
  methods: {
    /**
     * @description: 初始化
     * 1.后台获取菜单树
     * 2.获取系统路由配置信息，整理得到页面元素与菜单的对象集合
     * 3.整合菜单树与页面元素，初始化包含页面元素的菜单树
     * 4.后台获取岗位菜单维护关系
     * 5.整理新菜单树的所有子节点，整理岗位菜单维护关系树形关系为一维数组
     * 6.对照新菜单树的所有子节点，选取存在于岗位菜单维护关系的节点，设置树勾选
     * @param {*}
     * @return {*}
     */
    async init () {
      await this.getMenuTree();
      await this.initRoutes();
      await this.initMenuTree();
      this.getByRoleCode();
    },
    /**
     * @description: 1.后台获取菜单树
     * @return {*}
     */
    getMenuTree () {
      return menuTree(this.fd.securityType)
        .then(rsp => {
          if (rsp.data && rsp.data.length > 0) {
            this.defaultExpandedKeys = [rsp.data[0].nodeCode];
          }
          this.menuData = rsp.data || [];
          Promise.resolve();
        })
        .catch(err => {
          console.error('查询菜单出错', err);
          Promise.reject(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 2.获取系统路由配置信息，整理得到页面元素与菜单的对象集合
     * @param {*}
     * @return {*}
     */
    initRoutes () {
      return new Promise((resolve, reject) => {
        const routes = this.$router.options.routes;
        // 格式化系统路由信息，把系统的层级路由信息展开为一维数组
        const formatRoutes = [];
        this.formatRoutes(routes, '', formatRoutes);
        /* 将菜单路由配置信息与页面元素信息组合成对象集合 Start */
        const elements = {};
        formatRoutes.map(item => {
          if (item.path && item.meta && item.meta.menuElements && item.meta.menuElements.length > 0) {
            elements[item.path] = item.meta.menuElements;
          }
        });
        this.menuElements = elements;
        /* 将菜单路由配置信息与页面元素信息组合成对象集合 End */
        resolve();
      });
    },
    /**
     * @description: 格式化系统路由信息，把系统的层级路由信息展开为一维数组
     * @param {Array} _data 循环的数组
     * @param {String} parentPath 上层菜单路径
     * @return {*}
     */
    formatRoutes (_data, parentPath, arr) {
      // 遍历数据
      _data.forEach(item => {
        // 拷贝节点信息
        const _routeData = JSON.parse(JSON.stringify(item));
        if (parentPath !== '/' && item.path[0] !== '/') {
          _routeData.path = parentPath + '/' + item.path;
        } else {
          _routeData.path = parentPath + item.path;
        }
        // 将节点信息存储到提交数组
        arr.push(_routeData);
        // 如果节点的子节点长度大于0，再次遍历
        if (item.children && item.children.length > 0) {
          this.formatRoutes(item.children, _routeData.path, arr);
        }
        // 删除多余节点
        delete (_routeData.component);
        delete (_routeData.beforeEnter);
        delete (_routeData.redirect);
        delete (_routeData.children);
      });
    },
    findAllChildren (data, arr, childNodesProp = 'childNodes') {
      data.forEach((item, index) => {
        if (item[childNodesProp] && item[childNodesProp].length !== 0) {
          this.findAllChildren(item[childNodesProp], arr);
        } else {
          arr.push(item);
        }
      });
    },
    /**
     * @description: 3.整合菜单树与页面元素，初始化包含页面元素的菜单树
     * @param {*}
     * @return {*}
     */
    initMenuTree () {
      return new Promise((resolve, reject) => {
        // 将系统路由配置的页面元素信息与后台返回的菜单树结合(将页面元素挂在对应的菜单子节点)
        this.routesMenuTree = this.formatRoutesMenu(this.menuElements, this.menuData);
        // 5.整理新菜单树的所有子节点
        this.findAllChildren(this.routesMenuTree, this.leafMenuList);
        resolve();
      });
    },
    /**
     * @description: 将系统路由配置的页面元素信息与后台返回的菜单树结合(将页面元素挂在对应的菜单子节点)
     * @param {*}
     * @return {*}
     */
    formatRoutesMenu (_menuElements, _menuData) {
      const menuData = _.cloneDeep(_menuData);
      const recursiveData = (_recursiveData) => {
        // 遍历数据
        _recursiveData.forEach(item => {
          // 菜单节点有url信息，即菜单是叶子节点
          if (item.url) {
            // 从路由页面元素对象集合中获取对应的菜单页面元素
            const elements = _menuElements[item.url];
            // 路由配置了页面元素
            if (elements && elements.length > 0) {
              // 菜单子节点创新下级节点数组
              if (!item.childNodes) {
                item.childNodes = [];
              }
              // 页面元素循环插入下级节点数组中
              elements.forEach(elItem => {
                item.childNodes.push({
                  nodeCode: item.nodeCode + '&&elementCode&&' + elItem.elementCode, // 节点编码组合：插入的菜单编码 + &&elementCode&& + 页面元素编码（记录插入的菜单编码，便于保存时处理数据插入位置）
                  nodeName: elItem.elementName,
                  menuType: 'element'
                });
              });
            }
          }
          if (item.childNodes && item.childNodes.length > 0) {
            recursiveData(item.childNodes);
          }
        });
      };
      recursiveData(menuData);
      return menuData;
    },
    /**
     * @description: 4.后台获取岗位菜单维护关系
     * @param {*}
     * @return {*}
     */
    getByRoleCode () {
      this.loading = true;
      menuRoleService.getByRoleCode(this.fd.roleCode)
        .then(rsp => {
          this.fd.sysMenuVOList = rsp.data || [];
          this.setCheckedKeys(this.fd.sysMenuVOList);
        })
        .catch(err => {
          console.error('查询岗位关联对应的菜单出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 初始化步骤5&6
     * @param {Object} data
     * @return {*}
     */
    setCheckedKeys (data) {
      // 5.整理岗位菜单维护关系树形关系为一维数组
      const nodeCodeList = [];
      data.forEach((item) => {
        if (item.elements && item.elements.length > 0) {
          item.elements.forEach((elItem) => {
            nodeCodeList.push(item.menuCode + '&&elementCode&&' + elItem.elementCode);
          });
        }
        nodeCodeList.push(item.menuCode);
      });
      // 6.对照新菜单树的所有子节点，选取存在于岗位菜单维护关系的节点，设置树勾选
      const checkedChildNodeCodeList = [];
      this.leafMenuList.forEach(leafItem => {
        if (nodeCodeList.includes(leafItem.nodeCode)) {
          checkedChildNodeCodeList.push(leafItem.nodeCode);
        }
      });
      console.log('菜单树勾选的节点:', checkedChildNodeCodeList);
      this.$refs.tree.setCheckedKeys(checkedChildNodeCodeList);
    },
    /**
     * @description: 更新岗位菜单
     * @param {*}
     * @return {*}
     */
    async handleSave () {
      this.loading = true;
      const checkedNodesFd = [];
      await this.getCheckNodes(checkedNodesFd);
      menuRoleService.saveByRoleCode(this.fd.roleCode, checkedNodesFd)
        .then(rsp => {
          this.$alert('岗位菜单更新成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success'
          });
          this.$emit('closeDialog', '');
        })
        .catch(err => {
          console.error('岗位菜单更新出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取树结构勾选的参数，整理为接口需要的fd
     * @param {*}
     * @return {*}
     */
    getCheckNodes (checkedNodesFd) {
      return new Promise((resolve, reject) => {
      // 获取菜单树已勾选的节点
        const checkedNodesList = this.$refs.tree.getCheckedNodes(false, true);
        console.log('获取菜单树勾选的节点:' + checkedNodesList);
        // 已勾选的（页面元素）节点集合--对象，便于后续快速获取页面元素插入菜单
        const elementsNodesFd = {};

        /* 循环菜单树已勾选的节点，将节点分类保存：菜单（插入fd中）、页面元素（待处理） Start */
        checkedNodesList.forEach(nodeItem => {
        // 页面元素处理
          if (nodeItem.menuType === 'element') {
          // 截取页面元素所属菜单的编码
            const menuCode = nodeItem.nodeCode.split('&&')[0];
            // 页面元素集合对象不存在，定义空数组
            if (!elementsNodesFd[menuCode]) {
              elementsNodesFd[menuCode] = [];
            }
            elementsNodesFd[menuCode].push(
              {
                elementCode: nodeItem.nodeCode.split('&&')[2]
              }
            );
          } else {
          // 菜单处理
            checkedNodesFd.push(
              {
                elements: [],
                menuCode: nodeItem.nodeCode,
                menuUrl: nodeItem.url
              }
            );
          }
        });
        /* 循环菜单树已勾选的节点，将节点分类保存：菜单、页面元素 End */

        // 循环 菜单节点集合，将页面元素插入对应位置
        checkedNodesFd.forEach(menuItem => {
          const element = elementsNodesFd[menuItem.menuCode];
          if (element) {
            menuItem.elements = element;
          }
        });
        resolve();
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    // 1. 读取 roleCode 必须
    this.fd.roleCode = this.dlParams.roleCode;
    this.fd.roleName = this.dlParams.roleName;
    this.fd.securityType = this.dlParams.securityType;
    this.fd.securityName = this.dlParams.securityName;
    // 2. 判断 roleCode 不存在则抛出错误
    if (this.fd.roleCode === '') {
      this.$alert('请重新选择岗位后再操作！', '提示', {
        type: 'warning',
        callback: () => {
          this.closeDialog();
        }
      });
    } else {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
@import './role.scss';

.dev-element-sign{
  display: inline-block;
  box-sizing: border-box;
  width: 10px;
  height: 10px;
  margin-right: 4px;
  border: 2px solid #67C23A;
  border-radius: 50%;
}

</style>
